<div class="toast-container">
  @for (toast of toasts; track toast.id) {
    <div class="toast-back" [ngClass]="{ 'delete-toast': toast.deleteProcess }">
      <div
        class="toast-item"
        [ngClass]="{
          'toast-item--success': toast.type === TOAST_TYPE.SUCCESS,
          'toast-item--error': toast.type === TOAST_TYPE.ERROR,
        }"
        role="alert"
      >
        <span class="material-symbols-outlined"> {{ TOAST_ICON[toast.type] }} </span>
        {{ toast.msg }}
      </div>
    </div>
  }
</div>
